import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import useCalendarToggle from "../hooks/useCalendarToggle";

const DayNavigator = ({
  selectedDate,
  setSelectedDate,
  dayNumber,
  startDate,
}) => {
  const { showCalendar, setShowCalendar, calendarRef } = useCalendarToggle();

  const getDateFromDayNumber = (dayNumber, startDate) => {
    const base = new Date(startDate);
    base.setDate(base.getDate() + dayNumber);
    console.log("Base date: ", base);
    return base;
  };

  const goToPreviousDay = () => {
    const newDay = dayNumber - 1;
    console.log(newDay);
    setSelectedDate(getDateFromDayNumber(newDay, startDate));
  };

  const goToNextDay = () => {
    const newDay = dayNumber + 1;
    setSelectedDate(getDateFromDayNumber(newDay, startDate));
  };

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const format = (date) =>
    `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
  const todayStr = format(today);
  const tomorrowStr = format(tomorrow);
  const selectedStr = format(selectedDate);

  return (
    <div className="tw-flex tw-gap-3 tw-justify-between tw-w-full">
      <div className="tw-flex tw-items-center tw-gap-3">
        <button
          className="tw-hidden lg:tw-flex tw-bg-gray-200 dark:tw-bg-gray-800 tw-rounded-full tw-px-2 tw-py-2 hover:tw-bg-gray-300 dark:hover:tw-bg-gray-300 dark:hover:tw-text-black"
          onClick={goToPreviousDay}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="tw-w-4 tw-h-4"
          >
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m15.5 5.5-7 7 7 7"
            />
          </svg>
        </button>
        <span className="tw-font-medium tw-text-xl xl:tw-text-2xl tw-px-4">
          {dayNumber >= 1 ? `Day ${dayNumber}` : `Day -`}
        </span>
        <button
          className="tw-hidden lg:tw-flex tw-bg-gray-200 dark:tw-bg-gray-800 tw-rounded-full tw-px-2 tw-py-2 hover:tw-bg-gray-300 dark:hover:tw-bg-gray-300 dark:hover:tw-text-black"
          onClick={goToNextDay}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="tw-w-4 tw-h-4"
          >
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m8.5 5.5 7 7-7 7"
            />
          </svg>
        </button>
      </div>
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-flex tw-gap-2">
          <span
            onClick={() => setSelectedDate(today)}
            className={`tw-cursor-pointer tw-px-5 tw-py-2 tw-rounded-full ${
              selectedStr === todayStr
                ? "tw-bg-black tw-text-white dark:tw-bg-white dark:tw-text-black hover:tw-bg-black/80"
                : "tw-bg-gray-200 hover:tw-bg-gray-300 dark:tw-bg-gray-800 dark:hover:tw-bg-gray-300 dark:hover:tw-text-black"
            }`}
          >
            Today
          </span>
          <span
            onClick={() => setSelectedDate(tomorrow)}
            className={`tw-hidden lg:tw-flex tw-cursor-pointer tw-px-5 tw-py-2 tw-rounded-full ${
              selectedStr === tomorrowStr
                ? "tw-bg-black tw-text-white dark:tw-bg-white dark:tw-text-black hover:tw-bg-black/80"
                : "tw-bg-gray-200 hover:tw-bg-gray-300 dark:tw-bg-gray-800 dark:hover:tw-bg-gray-300 dark:hover:tw-text-black"
            }`}
          >
            Tomorrow
          </span>
        </div>
        <div ref={calendarRef} className="tw-relative tw-inline-block">
          <button
            type="button"
            className={`tw-px-6 tw-py-3 tw-rounded-full tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-h-full ${
              selectedStr !== todayStr && selectedStr !== tomorrowStr
                ? "tw-bg-black tw-text-white dark:tw-bg-white dark:tw-text-black hover:tw-bg-black/80"
                : "tw-bg-gray-200 hover:tw-bg-gray-300 dark:tw-bg-gray-800 dark:hover:tw-bg-gray-300 dark:hover:tw-text-black"
            }`}
            onClick={() => setShowCalendar(!showCalendar)}
          >
            <svg
              className="tw-w-6 tw-h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 7V3m8 4V3m-9 8h10m-12 9h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2z"
              ></path>
            </svg>
          </button>

          {showCalendar && (
            <div className="tw-absolute tw-z-50 tw-mt-2 tw-right-0 tw-bg-white  dark:tw-bg-black tw-p-4 tw-rounded-3xl tw-shadow-lg">
              <Calendar
                value={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowCalendar(false);
                }}
                minDate={new Date("2024-01-01")}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayNavigator;
